<template>
  <div class="wrapper">
    <div class="sticky-header">
      <div
        class="card-body pointer car-brief-area"
        @click="() => selectCar(selectedCar.id) && clearTrack()"
      >
        <font-awesome-icon
          icon="search-location"
          class="search-location-icon"
          size="1x"
          :style="{ color: 'gray' }"
        />
        {{ car.model }} {{ car.brand }} ({{ car.registration_plate }})
      </div>
      <div class="card-header">
        <ul class="nav nav-tabs card-header-tabs justify-content-center">
          <font-awesome-icon
            icon="times"
            class="back-button"
            @click="selectCar(undefined)"
          />
          <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" href="#info">Инфо</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#history">История</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#commands">Команды</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="card-body">
      <div class="tab-content">
        <!--<INFO>-->
        <div class="tab-pane fade active show" id="info"><MapCardInfo /></div>
        <!--</INFO>-->
        <!--<HISTORY>-->
        <div class="tab-pane fade" id="history"><MapCardHistory /></div>
        <!--</HISTORY>-->
        <!--<COMMANDS>-->
        <div class="tab-pane fade" id="commands"><MapCardCommands /></div>
        <!--</COMMANDS>-->
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import dayjs from 'dayjs'
export default {
  name: 'CardSelected',
  computed: {
    ...mapState('taxi/mapcars', {
      car: state => state.items.find(car => car.id === state.selectedCar.id),
      selectedCar: state => state.selectedCar
    })
  },
  watch: {
    car: {
      handler (car, carOld) {
        if (car?.id !== carOld?.id) {
          this.getStartTrack({
            id: car.id,
            startTimeOfTrack: dayjs(new Date() - (60 * 60 * 1000) * 6).format('YYYY-MM-DDTHH:mm:ss'),
            endTimeOfTrack: dayjs(new Date() - (60 * 60 * 1000) * 5).format('YYYY-MM-DDTHH:mm:ss')
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('taxi/mapcars', [
      'getStartTrack',
      'selectCar',
      'clearTrack'
    ])
  }
}
</script>
<style lang="scss" scoped>
  .card-header {
    background-color: white !important;
  }
  .nav-tabs {
    border: none;
  }
  .nav-item .nav-link {
    border: none;
    color: #212529;
  }
  .nav-item .nav-link.active {
    color: #0597f2;
    border-bottom: 2px solid #0597f2;
  }
  .card-header {
    padding: 0;
  }
  .sticky-header {
    position: sticky;
    top: 0;
    z-index: 9999;
    background-color: white;
  }
  .card-header-tabs {
    margin: 0;
  }
  .wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% - 3px);
    background-color: white;
    z-index: 9998;
    margin-left: 3px;
    height: 100%;
    overflow-y: auto;
  }
  .back-button {
    color: #55606a;
    opacity: 0.7;
    width: 22px;
    height: 22px;
    position: absolute;
    right: 1rem;
    top: 1rem;
  }
  .back-button:hover {
    opacity: 1 !important;
    cursor: pointer;
  }
  .pointer {
    cursor: pointer;
  }
  .car-brief-area {
    text-align: center;
    &:hover {
      .search-location-icon {
        color: #0597f2 !important;
      }
    }
  }
</style>
